<template>
	<div>
		<div class="row">

			<div class="col-12 w-100 p-0 px-lg-3" v-if="is_loading">
				<ul class="list-group list-group-flush mb-3 border loading skeleton_cart_list"></ul>
			</div>

			<div class="col-12 col-lg-6 offset-lg-3" v-else-if="arr.length == 0">
				<img :src="no_transaction_img" class="img-fluid" alt="No Transaction Here">
				<h5 class="text-center mt-4 w-100 mb-4">{{ no_transaction_label }}</h5>
			</div>

			<div v-else class="col-12 p-0 px-lg-3">

				<div v-if="tab.id == 'waiting_for_payment'">
					<ul class="list-group list-group-flush p-3 p-lg-4 mb-3 border" v-for="(data, index) in arr" :key="index">

						<li class="list-group-item pt-0 pb-3 pb-lg-4 border-top-0">
							<div class="row">
								<div class="col-6 p-0">
									<p class="m-0 font-weight-bold">{{ data.date }}</p>
									<p class="m-0 font-weight-bold">#{{ data.id }}</p>
								</div>

								<div class="col-6 p-0 text-right">
									<p class="m-0 font-weight-bold" style="color: #777777;">{{ data.courier_name }}</p>
									<p class="m-0 font-weight-bold" style="color: #777777;">Rp. {{ data.cost_delivery }} <span v-show="data.total_weight != null">{{ '(' + data.total_weight + ' Gr)' }}</span></p>
								</div>
							</div>
						</li>

						<li class="list-group-item py-3 py-lg-4" v-for="(data1, index1) in data.list_book" :key="index1">
							<div class="row book">
								<div class="col-12 col-lg-6">
									<div class="row">
										<div class="col-3 pl-0">
											<div class="book-ratio" :style="{ 'backgroundImage': 'url(' + data1.photo + ')', }" @click="book_detail(data1.id)"></div>
										</div>

										<div class="col pl-0">
											<div class="d-flex flex-column justify-content-between h-100">
												<div class="align-self-start">
													<div class="">
														<p class="book-title opt2" style="-webkit-box-orient: vertical; cursor: pointer;" @click="book_detail(data1.id)">{{ data1.title }}</p> 
													</div>

													<div class="">
														<p class="d-inline-block m-0">{{ by_label }} </p>
														<a href="#!" class="text-info">{{ data1.author }}</a>
													</div>
												</div>

												<div class="">
													<p class="m-0" style="text-decoration: line-through" v-show="data1.original_price != data1.price">Rp. {{ data1.original_price.toLocaleString('id-ID') }}</p>
													<p class="text-primary d-inline-block m-0 font-weight-bold">Rp. {{ data1.price.toLocaleString('id-ID') }}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								
								<div class="col-lg-6 pr-0 d-none d-lg-flex flex-column justify-content-end align-items-end">
									<div class="d-flex justify-content-start">
										<p class="m-0">{{ qty_label }}: </p>
										<p class="m-0 ml-2 text-primary font-weight-bold">{{ data1.quantity }}</p>
									</div>

									<div class="d-flex justify-content-start">
										<p class="m-0">{{ subtotal_label }}</p>
										<p class="m-0 ml-2 text-primary font-weight-bold">Rp. {{ data1.sub_total }}</p>
									</div>

									<!-- <div class="d-flex justify-content-start" v-if="data1.discount_mount > 0">
										<p class="m-0">@{{ data1.type_disc }}</p>
										<p class="m-0 ml-2 text-primary font-weight-bold">{{ data1.discount_mount }}%</p>
									</div> -->
								</div>

								<div class="col-12 px-0 mt-3 d-flex justify-content-between d-lg-none">
									<div class="d-flex justify-content-start">
										<p class="m-0">{{ qty_label }}: </p>
										<p class="m-0 ml-2 text-primary font-weight-bold">{{ data1.quantity }}</p>
									</div>

									<div class="d-flex justify-content-start">
										<p class="m-0">{{ subtotal_label }}</p>
										<p class="m-0 ml-2 text-primary font-weight-bold">Rp. {{ data1.sub_total }}</p>
									</div>

									<!-- <div class="d-flex justify-content-start">
										<p class="m-0">{{ data1.type_disc }}</p>
										<p class="m-0 ml-2 text-primary font-weight-bold">{{ data1.discount_mount }}%</p>
									</div> -->
								</div>
							</div>
						</li>

						<li class="list-group-item p-0 py-3 py-lg-4">
							<div class="row">
								<div class="col-auto">
									<a :href="url_invoice + data.id" target="_blank" class="text-primary">{{ view_invoice_label }}</a>
									<a :href="base_url + '/' + data.urlBukti" target="_blank" class="text-primary" v-show="data.urlBukti != null && data.urlBukti != ''">{{ view_transfer_proof_label }}</a>
								</div>

								<div class="col text-right">
									<p class="d-inline-block m-0">{{ total_order_label }}: </p>
									<p class="d-inline-block m-0 ml-2 text-primary font-weight-bold">Rp. {{ data.total_belanja }}</p>
								</div>
							</div>

							<div class="d-flex justify-content-between align-items-center">
							</div>
						</li>

						<li class="list-group-item p-0 pt-3 pt-lg-4 border-bottom-0">
							<div class="row">
								<div class="col-auto d-flex align-items-center">
									<p class="d-inline-block m-0">
										<b>{{ payment_remaining_label }}: {{ arr_time_remaining.length > 0 && arr_time_remaining[index] != null ? arr_time_remaining[index].timer_pembayaran : '-' }}</b>
									</p>
								</div>

								<div class="col text-right">
									<button class="btn btn-primary" href="#!"
										@click="onConfirmClicked(index)" 
										v-show="arr_time_remaining.length > 0 && arr_time_remaining[index] != null && arr_time_remaining[index].timer_pembayaran != '-'">
										{{ confirm_label }}
									</button>

									<button class="btn btn-outline-primary"
										@click="onCancelClicked(index)" 
										v-show="arr_time_remaining.length > 0 && arr_time_remaining[index] != null && arr_time_remaining[index].timer_pembayaran != '-'">
										{{ cancel_label }}
									</button>
								</div>
							</div>
						</li>

					</ul>

					<div class="modal fade" ref="confirm_modal" tabindex="-1" role="dialog" aria-labelledby="confirm_modalTitle" aria-hidden="true">
						<div class="modal-dialog modal-dialog-scrollable" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title" id="confirm_modalTitle">{{ payment_confirmation_label }}</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close">
										<span aria-hidden="true">&times;</span>
									</button>
								</div>

								<div class="modal-body">
									<form autocomplete="off" action="" v-if="is_confirm_form">
										<div class="form-group">
											<label for="ta-nama">{{ bank_name_label }}</label>
											<input type="text" class="form-control" name="ta-nama" id="ta-nama" aria-describedby="ta-nama" :placeholder="bank_name_label" v-model="bank_name">
										</div>

										<div class="form-group">
											<label for="ta-acc_num">{{ acc_no_label }}</label>
											<input type="text" class="form-control" name="ta-acc_num" min="0" id="ta-acc_num" aria-describedby="ta-acc_num" :placeholder="acc_no_label" v-model="account_number">
										</div>

										<div class="form-group">
											<label for="ta-acc_name">{{ acc_name_label }}</label>
											<input type="text" class="form-control" name="ta-acc_name" id="ta-acc_name" aria-describedby="ta-acc_name" v-model="account_name">
										</div>

										<div class="form-group">
											<input type="file" class="form-control d-none" name="bukti_transfer" ref="bukti_transfer" accept="image/*" aria-describedby="bukti_transfer" v-on:change="display_bukti">
											<button class="btn btn-sm btn-primary" type="button" @click="() => $refs.bukti_transfer.click()">{{ upload_proof_label }}</button> <small>({{ optional_label }})</small>
											<div class="mt-3" v-if="proof_image != ''">
												<img :src="proof_image" style="height: 10rem">
											</div>
										</div>
									</form>

									<div class="row" v-else>
										<div class="col-lg-6 offset-lg-3 col-8 offset-2 mt-4 text-center">
											<img :src="wait_payment_url" class="img-fluid">
											<h5 class="m-0 mt-3">{{ loading_label }}</h5>
										</div>
									</div>
								</div>

								<div class="modal-footer" v-if="is_confirm_form">
									<button type="button" class="btn btn-secondary" data-dismiss="modal">{{ cancel_label }}</button>
									<button type="button" class="btn btn-primary" :disabled="is_disabled_confirmation" v-on:click="save">{{ confirm_label }}</button>
								</div>
							</div>
						</div>
					</div>

					<div class="modal fade" ref="cancel_order" tabindex="-1" role="dialog" aria-labelledby="cancel_orderTitle" aria-hidden="true">
						<div class="modal-dialog modal-dialog-scrollable" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title" id="confirm_modalTitle">{{ cancel_confirmation_title }}</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close">
										<span aria-hidden="true">&times;</span>
									</button>
								</div>

								<div class="modal-body py-0">
									<div v-if="is_confirm_form">
										<p>{{ cancel_confirmation_label }}</p>
									</div>

									<div class="row" v-else>
										<div class="col-lg-6 offset-lg-3 col-8 offset-2 mt-4 text-center">
											<img :src="wait_payment_url" class="img-fluid">
											<h5 class="m-0 mt-3">{{ loading_label }}</h5>
										</div>
									</div>
								</div>
								
								<div class="modal-footer">
									<button type="button" class="btn btn-secondary" data-dismiss="modal">{{ cancel_label }}</button>
									<button type="button" class="btn btn-primary" v-on:click="cancel_order">{{ yes_label }}</button>
								</div>
							</div>
						</div>
					</div>

				</div>

				<div v-else>
					<order_history v-for="(data, index) in arr" :key="index" 
						:qty_label="qty_label"
						:subtotal_label="subtotal_label"
						:finish_order_label="finish_order_label"
						:confirmation_finish_order_title="confirmation_finish_order_title"
						:confirmation_finish_order_label="confirmation_finish_order_label"
						:cancel_label="cancel_label"
						:yes_label="yes_label"
						:view_invoice_label="view_invoice_label"
						:total_order_label="total_order_label"
						:history_arr="data" 
						:invoice_url="invoice_url" 
						:detail_url="detail_url"
						
						:base_url="base_url"
						:view_transfer_proof_label="view_transfer_proof_label"/>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
	import Base from '../base'
	import _ from 'lodash'
	import moment from 'moment'

	export default {
		props:[
			'tab', 'selected_tab', 'index', 'no_transaction_img', 'no_transaction_label', 'qty_label', 'subtotal_label', 'finish_order_label', 'confirmation_finish_order_title', 'confirmation_finish_order_label', 'cancel_label', 'yes_label', 'view_invoice_label', 'total_order_label', 'invoice_url', 'detail_url', 'url_payment_list', 'url_image', 'by_label', 'url_invoice', 'payment_remaining_label', 'confirm_label','payment_confirmation_label', 'bank_name_label', 'acc_no_label', 'acc_name_label', 'optional_label', 'wait_payment_url', 'loading_label', 'cancel_confirmation_title', 'bank_name_empty', 'account_name_empty', 'account_number_empty', 'upload_proof_label', 'cancel_confirmation_label',
			'csrf_token', 'base_url', 'url_confirmation_payment', 'url_cancel_order', 'url_book_detail', 'view_transfer_proof_label',
		],
		data() {
			return{
				base: null,

				is_loading: false,
				is_confirm_form: true,
				arr: [],
				arr_time_remaining: [],

				bank_name: '',
				account_number: '',
				account_name: '',
				proof_image: '',
				proof_image_data: {},

				selected_index: -1,
			}
		},
		computed: {
			is_disabled_confirmation(){
				return this.bank_name == '' || this.account_number == '' || this.account_name == ''
			},
		},
		watch: {
			arr_time_remaining(val){
				var context = this

				setTimeout(function() {
					var arr = _.cloneDeep(val)
					var now = moment()
					for(let data of arr){
						if(data.dueDate != null && data.dueDate.isSameOrAfter(now)){
							var duration = moment.duration(data.dueDate.diff(now, 'seconds'), 's')

							data.timer_pembayaran = (duration.hours() < 10 ? '0' + duration.hours() : duration.hours()) + ":" + (duration.minutes() < 10 ? '0' + duration.minutes() : duration.minutes()) + ":" + (duration.seconds() < 10 ? '0' + duration.seconds() : duration.seconds())
						}
						else
							data.timer_pembayaran = '-'
					}
					context.arr_time_remaining = arr
				}, 1000)
			},
			selected_tab(val){
				this.base.save_tab('list_order', val)
				if(val == this.tab.id)
					this.payment_list()
			},
		},
		created(){
			this.base = new Base()
		},
		mounted() {
			// console.log(this.history_arr)
			var context = this

			this.get_profile()
			if(this.selected_tab == this.tab.id)
				this.payment_list()
		},
		methods:{
			async get_profile(){
				this.is_loading = true

				var response = await axios.get(this.base_url + '/profile-data', {
					headers:{
						'Content-Type': 'application/json'
					}
				})

				this.is_loading = false
				if(response.data.data != null){
					this.account_number = response.data.data.account_number
					this.account_name = response.data.data.account_name
					this.bank_name = response.data.data.bank_name
				}
			},
			async payment_list(){
				this.is_loading = true
				this.arr = []

				var response = await axios.get(this.url_payment_list + '?tab=' + this.tab.id, {
					headers:{
						'Content-Type': 'application/json'
					}
				})

				if(response.data.data != null){
					this.is_loading = false
					var arr_temp = []
					for(let data of response.data.data){
						var arr = {}
						arr.id = data.id

						arr.date = moment(data.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY - LT')
						arr.courier_name = data.courier_name
						arr.cost_delivery = data.courier_cost
						arr.weight = data.weight
						arr.total_belanja = data.total_belanja
						arr.status_order = data.status
						arr.urlBukti = data.urlBukti

						if(this.tab.id == 'waiting_for_payment'){
							arr.timer_pembayaran = '-'
							arr.dueDate = moment(data.created_at, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours')
							
							/*if(data.account_number != null){
								waiting_payment_list.is_disabled = false

								waiting_payment_list.bank_name = data.bank_name
								waiting_payment_list.account_name = data.account_name
								waiting_payment_list.account_number = data.account_number
							}*/
						}

						arr.list_book = []

						for(let book of data.book){
							var arr_book = {}
							arr_book.id = book.id
							arr_book.title = book.title
							arr_book.author = book.author.name
							arr_book.original_price = book.price
							arr_book.price = book.get_price
							arr_book.photo = this.url_image + book['url_photo']
							arr_book.quantity = book.quantity
							arr_book.sub_total = book.sub_total

							arr_book.type_disc = book.type_disc
							arr_book.discount_mount = book.discount

							arr.list_book.push(arr_book)
						}

						arr_temp.push(arr)
					}
					this.arr_time_remaining = arr_temp
					this.arr = arr_temp
				}
			},
			onConfirmClicked(index){
				this.selected_index = index
				$(this.$refs.confirm_modal).modal('show')
			},
			onCancelClicked(index){
				this.selected_index = index
				$(this.$refs.cancel_order).modal('show')
			},
			book_detail(id){
				location.href = this.url_book_detail + "?id=" + id
			},
			display_bukti(event){
				this.proof_image = URL.createObjectURL(event.target.files[0])
				this.proof_image_data = event.target.files[0]
			},
			async save(){
				if(this.bank_name == '')
					alert(this.bank_name_empty)
				else if(this.account_name == '')
					alert(this.account_name_empty)
				else if(this.account_number == '')
					alert(this.account_number_empty)
				else{
					var temp = this.arr[this.selected_index]
					this.is_confirm_form = false

					var formData = {
						_token : this.csrf_token,
						_method : 'put',
						id : temp.id,
						bank_name : this.bank_name,
						account_name : this.account_name,
						account_number : this.account_number,
					}

					if(this.proof_image != ''){
						// formData.file_bukti = await this.base.toDataURLPromise(this.proof_image)
						formData.file_bukti = this.proof_image_data
					}

					var response = await axios.post(this.url_confirmation_payment, formData, {
						headers:{
							'Content-Type': 'multipart/form-data'
						}
					})

					if(response.data.status == 'success'){
						$(this.$refs.confirm_modal).modal('hide')
						this.payment_list()
					}
					this.is_confirm_form = true
				}
			},
			async cancel_order(){
				var temp = this.arr[this.selected_index]

				this.is_confirm_form = false
				var response = await axios.post(this.url_cancel_order, {
					_token : this.csrf_token,
					_method : 'put',
					id : temp.id,
				}, {
					headers:{
						'Content-Type': 'application/json'
					}
				})
				this.is_confirm_form = true
				
				if(response.data.status == 'success'){
					$(this.$refs.cancel_order).modal('hide')
					this.payment_list()
				}
			},
		}
	}
</script>
